<template>
  <div>
    <dl class="price-wrapper">
      <dt>
        {{ $t('common.price') }}
      </dt>
      <dd>
        <VPrice :price="price" no-formatting />
      </dd>

      <template v-if="option">
        <dt>
          {{ $t('substore.option') }}
        </dt>
        <dd>
          {{ option.productName }}
          <br />
          <i>
            {{ option.productSubscriptionType }}
          </i>
        </dd>
      </template>
    </dl>
  </div>
</template>

<script>
import VPrice from '@/components/Substore/Price';

export default {
  name: 'AcePriceWrapper',

  components: {
    VPrice,
  },

  props: {
    tariff: {
      type: Object,
      required: false,
      default: null,
    },

    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    price() {
      if (!this.product.price) return {};
      const copy = { ...this.product.price, priceDisplay: true };
      if (this.tariff) {
        copy.value = this.tariff.price;
        copy.isExact = true;
      }

      return copy;
    },

    option() {
      const index = this.product.productGroupMembers?.findIndex(p => p.subscriptionTemplateId === this.tariff?.id);
      if (index === -1 || index === undefined) return null;

      this.$emit('override', index);
      return this.product.productGroupMembers[index];
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

@media screen and (min-width: #{$grid-medium-min}px) {
  .price-wrapper {
    display: flex;
    flex-wrap: wrap;

    dt {
      width: 41.66668%;
      padding-bottom: 12px;
    }

    dd {
      width: calc(58.33334% - 12px);
    }
  }
}
.price-wrapper {
  padding: 0;
  margin: 0;

  dt {
    font-weight: 600;
  }

  dd {
    margin-left: 12px;
  }
}
</style>
